import MatchesFilter from './_modules/sportdata/volley/matches-filter';
window.MatchesFilter = new MatchesFilter();

export default class MatchesFilters {
    constructor() {
      this.init();
    }
  
    init() {
      //
    }
  }
